// Module
var code = "<label class=\"avatar avatar-desktop avatar-away\" id=\"avatar\" title=\"More options\" data-detail='{\"click\": [ \r\n                            {\"dest\":\"ripple\" }, \r\n                             {\"dest\":\"drawer\", \"act\":\"show\" } ] }'>\r\n    <div class=\"title\"></div>\r\n    <div class=\"status\"></div>\r\n</label>";
// Exports
export default code;